import { Button } from "reactstrap";
import { useIntl } from "react-intl";

const LicenseExpiredButton = ({
  expired,
  programName,
  className,
  onClick,
  children,
}) => {
  const intl = useIntl();

  return (
    <span
      className="d-inline-block"
      tabIndex={expired ? 0 : undefined}
      title={
        expired
          ? intl.formatMessage(
              { id: "ProgramLicenseExpired" },
              { programName },
            )
          : undefined
      }
    >
      <Button
        outline
        color={expired ? "secondary" : "primary"}
        className={className}
        disabled={expired}
        onClick={onClick}
      >
        {children}
      </Button>
    </span>
  );
};

export default LicenseExpiredButton;
